<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="skt" ref="skt" style="margin-top:0;">
        <div class="select">
         <span class="xzqh">灾害发生地点:</span>
          <div class="selcountry">
            <el-input v-model="query.distPlace" clearable placeholder="请填写" @change="Global.emptyQuery(query.distPlace,thedata)"></el-input>
          </div>
          <span id="search" @click="thedata">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table v-loading="loading" :data="tdata" :max-height="height" :header-cell-style="{background:'##909399'}" border style="width: 100%; text-align: center;">
              <!-- <el-table-column type="selection" width="40" align="center">
              </el-table-column> -->
              <el-table-column  type="index" width="60" label="序号" align="center" header-align="center">
              </el-table-column>
              <el-table-column align="center" prop="distTime" label="灾害发生时间" min-width="120">
              </el-table-column>
              <el-table-column align="center" prop="distPlace" label="灾害发生地点" min-width="180">
              </el-table-column>
              <el-table-column align="center" prop="distRain"  label="过程降雨量（mm）" min-width="150">
              </el-table-column>
              <el-table-column align="center" prop="deathNum" label="死亡人数" min-width="150">
              </el-table-column>
              <el-table-column align="center" prop="missingNum" label="失踪人数" min-width="150">
              </el-table-column>
              <el-table-column align="center" prop="houseNum" label="损毁房屋（间）" min-width="150">
              </el-table-column>
              <el-table-column align="center" prop="transferNum" label="转移人数" min-width="150">
              </el-table-column>
              <el-table-column align="center" prop="economicLoss" label="直接经济损失（万元）" min-width="150">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <el-dialog
      class="abow_dialog"
      :close-on-click-modal="false"
      :title="status + '历史山洪调查信息'"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
        <el-form-item label="灾害发生时间:">
           <el-date-picker
            v-model="form.distTime"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="灾害发生地点:" prop="distPlace">
          <el-input v-model="form.distPlace"></el-input>
        </el-form-item>
        <el-form-item label="过程降雨量:" prop="distRain">
          <el-input v-model="form.distRain"></el-input>
          <label>(mm)</label>
        </el-form-item>
        <el-form-item label="死亡人数:" prop="deathNum">
          <el-input v-model="form.deathNum"></el-input>
          <label>(人)</label>
        </el-form-item>
        <el-form-item label="失踪人数:" prop="missingNum">
          <el-input v-model="form.missingNum"></el-input>
          <label>(人)</label>
        </el-form-item>
        <el-form-item label="损毁房屋:" prop="houseNum">
          <el-input v-model="form.houseNum"></el-input>
          <label>(间)</label>
        </el-form-item>
        <el-form-item label="转移人数:" prop="transferNum">
          <el-input v-model="form.transferNum"></el-input>
          <label>(人)</label>
        </el-form-item>
        <el-form-item label="直接经济损失:" prop="economicLoss">
          <el-input v-model="form.economicLoss"></el-input>
          <label>(万元)</label>
        </el-form-item>
        <el-form-item label="灾害描述:">
            <el-input
            type="textarea"
            :rows="2"
            v-model="form.distDescription"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
export default {
  data () {
    return {
      loading: true,
      height: 10,
      query: {},
      form: {},
      rules: {
        distPlace: [
          { required: true, message: '灾害地点不能为空' }
        ],
        distRain: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        deathNum: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        missingNum: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        houseNum: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        transferNum: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        economicLoss: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      },
      addbtn: false,
      pageIndex: '1',
      pageSize: '100',
      tdata: [],
      multipleSelection: [],
      status: '新增'
    }
  },
  methods: {
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_FLOODINFO, { distPlace: this.query.distPlace, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.loading = false
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.form = {}
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      if (this.multipleSelection.length === 1) {
        this.status = '编辑'
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
        this.Global.clearValidate(this, 'groupForm')
      } else {
        this.$alert('必需只选择一条信息', '提示')
      }
    },
    // 删除
    delDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('必需选择一条信息', '提示')
      } else {
        let ids = []
        this.multipleSelection.forEach(function (item) {
          ids.push(item.id)
        })
        this.$confirm(`确定要删除已选择的信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_FLOODINFO, { id: ids.join(',') }).then(() => {
            this.multipleSelection = []
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
            this.loading = false
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_FLOODINFO, this.form).then(() => {
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.loading = false
            this.addbtn = false
            this.form = {}
            this.multipleSelection = []
          }).catch(() => { this.loading = false })
        }
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    this.thedata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['skt'].style.height = (contentDiv[0].offsetHeight - 30) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
}
.scence >>> .el-dialog__body{
  height: 300px !important;
}
.el-form-item{
  margin-left: 1%;
  width: 44% !important;
}
.scence >>> .el-table__body,.scence >>> .el-table__header{
  width: auto!important;
}
</style>
